// extracted by mini-css-extract-plugin
export var active = "_2i-b";
export var activeIndicator = "_2i-6";
export var animate = "_2i-a";
export var disabled = "_2i-c";
export var flat = "_2i-1";
export var fullWidth = "_2i-3";
export var lg = "_2i-9";
export var md = "_2i-8";
export var redoButtonTabGroup = "_2i-0";
export var sm = "_2i-7";
export var tabButton = "_2i-4";
export var tabButtonsContainer = "_2i-2";
export var xs = "_2i-5";